import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { MoreVertical } from 'lucide-react';

/** Nút "⋮" mở menu thao tác của bài viết; danh sách mục do PostCard quyết định theo quyền */
export const PostDropdown: React.FC<{ items: MenuProps['items'] }> = ({ items }) => (
  <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
    <button
      aria-label="Thao tác bài viết"
      className="w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-center text-gray-500 transition cursor-pointer"
      onClick={e => e.stopPropagation()}
    >
      <MoreVertical className="w-5 h-5" />
    </button>
  </Dropdown>
);
